module.exports = __webpack_public_path__ + "img/coupon_popup_btn.da47bbf9.png";